<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Quality Inspection"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryqualityinspection"
        :documentId="mainRecordId"
        @saveMethod="finishDeliveryCard"
        @hideMethod="onHidden"
        ref="DeliveryQualityInspectionInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-delivery-instruction" ref="fieldset-delivery-instruction" :model.sync="inputQrCodeDiNumber" label="Delivery Instruction" @scannedMethod="scanDeliveryInstruction" :isBusy="isScanDeliveryInstructionLoading"  :isFocus="isScanDeliveryInstructionFocus"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="vwDeliveryQualityInspections != null && vwDeliveryQualityInspections.length > 0">
							<app-list :isDataLoading="isVwDeliveryQualityInspectionLoading"
								:dataCount="vwDeliveryQualityInspections.length">
								<delivery-instruction-item v-for="(item, index) in vwDeliveryQualityInspections" :model="item" :key="index"
									@nextAction="goToNextByDeliveryInstruction(2, item)" :isDisabled="checkIsVwDeliveryInstructionDisabled(item)" />
							</app-list>
						</span>

					</b-col>
				</b-row>
			</span><span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Delivery Instruction number" :model="model.deliveryInstructionDiNumber" />
						<app-input-scan id="fieldset-delivery-instruction-item" ref="fieldset-delivery-instruction-item" :model.sync="inputQrCodePart" label="Part" @scannedMethod="scanPart" :isBusy="isScanPartLoading" :isFocus="isScanPartFocus"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="DeliveryQualityInspectionDetails != null && DeliveryQualityInspectionDetails.length > 0">
							<app-list :isDataLoading="isDeliveryQualityInspectionDetailLoading"
								:dataCount="DeliveryQualityInspectionDetails.length">
								<delivery-quality-inspection-part v-for="(item, index) in DeliveryQualityInspectionDetails" :model="item" :key="index"
									@nextAction="goToNextBySelectPart(3, item)" :isDisabled="false" />
							</app-list>
						</span>

					</b-col>
				</b-row>
			</span>
			
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Delivery Instruction" :model="model.deliveryInstructionDiNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part No" :model="selectedDeliveryQualityInspectionDetail.part.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="selectedDeliveryQualityInspectionDetail.part.partName" />
						<app-label label-cols-lg="12" size="sm" label="Qty Delivery" :model="selectedDeliveryQualityInspectionDetail.qtyDeliver" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-scan-delivery-card" ref="fieldset-scan-delivery-card" :model.sync="inputQrCodeDeliveryCard" label="Scan Delivery Card" @scannedMethod="scanDeliveryCard" :isBusy="isScanDeliveryCardLoading" :waitInputScan="waitInputScanDeliveryCard" @clearMethod="clearMethodScanDeliveryCard" :isFocus="isScanDeliveryCardFocus"/>
						<app-input-combobox-autocomplete :options="QcStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="QC Status" id="input-qc-status" size="sm" :model.sync="selectedQcStatus" @input="getQcStatus" @focus="getQcStatus" :loading="isQcStatusLoading" @change="changeQcStatus" />
						<app-input-textbox id="fieldset-remark" label-cols-lg="12"  label="Remark" label-for="input-remark" size="sm" :model.sync="remarkInput" :isFocus="isRemarkInputFocus"/>
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-outline-success float-right"
				@click="getBack(scanPageIndex)">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right"
				@click="finishScanDeliveryQualityInspection()">Finish</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-outline-success float-right"
				@click="getBack(scanPageIndex)">Back</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right"
				@click="finishDeliveryCard()">Finish</b-button>

		</template>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstructionItem from '@/views/DeliveryQualityInspection/component/DeliveryInstructionItem';
import DeliveryQualityInspectionPart from '@/views/DeliveryQualityInspection/component/DeliveryQualityInspectionPart';
// import DeliveryInstructionItemDetail from '@/views/PickingForDelivery/component/DeliveryInstructionItemDetail';
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import DeliveryQualityInspectionScanner from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionScanner';
import DeliveryQualityInspection from '@/models/DeliveryQualityInspection/DeliveryQualityInspection';
import VwDeliveryQualityInspectionFilter from '@/filters/VwDeliveryQualityInspection/VwDeliveryQualityInspectionFilter';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import QcStatus from '@/models/QcStatus/QcStatus';
import DeliveryQualityInspectionDetail from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionDetail';
import DeliveryQualityInspectionDetailFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionDetailFilter';
import VwDeliveryQualityInspection from '@/models/VwDeliveryQualityInspection/VwDeliveryQualityInspection';
// import VwPickingForDeliveryDetailFilter from '@/filters/VwPickingForDeliveryDetail/VwPickingForDeliveryDetailFilter';
// import VwPickingForDeliveryDetail from '@/models/VwPickingForDeliveryDetail/VwPickingForDeliveryDetail';
// import PickingForDeliveryList from '@/models/PickingForDelivery/PickingForDeliveryList';
// import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PickingStatus from '@/models/PickingStatus/PickingStatus';
import PickingStatusFilter from '@/filters/PickingStatus/PickingStatusFilter';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';
import PickingCardDetail from '@/models/PickingForDelivery/PickingCardDetail';
import PickingCardDetailFilter from '@/filters/PickingForDelivery/PickingCardDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingForDeliveryDetailInput from '@/views/PickingForDelivery/PickingForDeliveryDetailInput';
import PickingForDeliveryDetailScan from '@/views/PickingForDelivery/PickingForDeliveryDetailScan';
import PickingForDeliveryDetailUpload from '@/views/PickingForDelivery/PickingForDeliveryDetailUpload';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PickingCardDetailInput from '@/views/PickingForDelivery/PickingCardDetailInput';
import PickingCardDetailScan from '@/views/PickingForDelivery/PickingCardDetailScan';
import PickingCardDetailUpload from '@/views/PickingForDelivery/PickingCardDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PickingForDeliveryDetailInput,
		PickingForDeliveryDetailScan,
		PickingForDeliveryDetailUpload,
		PickingCardDetailInput,
		PickingCardDetailScan,
		PickingCardDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		DeliveryInstructionItem,
		DeliveryQualityInspectionPart
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
			// deliveryInstructionId: {required},
		},
	},
	data() {
		return {
			deliveryInstructionId: '',
			modelId: '',
			modelIdOld: '',
			model: {},
			DeliveryQualityInspectionScannerObject : {},
			vwDeliveryQualityInspections : [],
			DeliveryQualityInspectionDetails : [],
			isScanDeliveryInstructionLoading : false,
			waitInputScanDeliveryCard : false,
			isScanDeliveryCardLoading : false,
			isScanPartLoading : false,
			isQcStatusLoading : false,
			isVwDeliveryQualityInspectionLoading : false,
			isDeliveryQualityInspectionDetailLoading : false,
			inputQrCodeDiNumber: '',
			inputQrCodePart:'',
			inputQrCodeDeliveryCard:'',
			busy:false,
			isBusy: false,
			isDataLoading: false,
			mainRecordId : '',
			remarkInput : '',
			scanPageIndex: 1,
			selectedDeliveryQualityInspectionDetail : {},
			QcStatuss : [],
			selectedQcStatus : '',

			isScanDeliveryInstructionFocus : false,
			isScanPartFocus : false,
			isScanDeliveryCardFocus : false,
			isRemarkInputFocus : false,
		}
	},
	methods : {
		changeQcStatus(){
			this.$nextTick(() => {
				this.focusInputRemark();
			});
		},
		async getBack(fromPage){
			let this_= this;
			

			if (fromPage ==2 && this_.modelIdOld) {
				await DeliveryQualityInspection.createData(this).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this_.getDeliveryQualityInspection(result.id);
							this.$router.replace('/deliveryqualityinspection/scan/' + result.id, async() => {
								return;
							});
						}
					}
					this.isCreateBusy = false;
				}).catch(error => {
					this.isCreateBusy = false;
				})
			}
			this.goToNext(fromPage-1);
		},
		resetFocusScan(){
			this.$nextTick(() => {
				this.isScanDeliveryInstructionFocus = false;
				this.isScanPartFocus = false;
				this.isScanDeliveryCardFocus = false;
				this.isRemarkInputFocus = false;
			});
		},
		focusScanPart(){
			this.resetFocusScan();
			this.isScanPartFocus = true;
			return;
		},
		focusScanDeliveryCard(){
			this.resetFocusScan();
			this.isScanDeliveryCardFocus = true;
			return;
		},
		focusScanDeliveryInstruction(){
			this.resetFocusScan();
			this.isScanDeliveryInstructionFocus = true;
			return;
		},
		focusInputRemark(){
			this.resetFocusScan();
			this.isRemarkInputFocus = true;
		},
		printList(){

			this_.toast({message: 'Success !', title:'Info', variant : 'nanti print disini',autoHideDelay:750});
		},
		checkIsVwDeliveryInstructionDisabled(iten){
			return false;
		},
		checkIsDeliveryInstructionDetailDisabled(iten){
			return false;
		},
		async scanDeliveryInstruction() {
			let qrCode = encodeURIComponent(this.inputQrCodeDiNumber);
			// console.log('qrCode',qrCode);
			this.isScanDeliveryInstructionLoading = true;
			let id = this.model.id;
			// // console.log(model);
			let this_ = this;
			let toPage = 2;
			this.DeliveryQualityInspectionScannerObject.deliveryInstructionNumber = qrCode;
			this.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId = '';
			// console.log('this.DeliveryQualityInspectionScannerObject',this.DeliveryQualityInspectionScannerObject.deliveryInstructionNumber);

			await DeliveryQualityInspectionScanner.doRequest(this,'scandeliveryinstruction',this.DeliveryQualityInspectionScannerObject)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId = result.id;
						//nanti go to next
						await this_.getDeliveryQualityInspection(result.id);
						// console.log('masuk sini buat get detail');
						await this_.doRedirect();
						await this_.getDeliveryQualityInspectionDetails();
						// // console.log('this_.modelId',this_.modelId)
						// // console.log('this_.doRedirect();',await this_.doRedirect())
						

						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Instruction !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			
			this.DeliveryQualityInspectionScannerObject.deliveryInstructionNumber = '';
			this.isScanDeliveryInstructionLoading = false;
			this.inputQrCodeDiNumber = '';
			return;
		},
		async doRedirect(){
			let this_ = this;
			// console.log('doRedirect old id=>',this_.modelIdOld)
			// return;
			this.$router.replace('/deliveryqualityinspection/scan/' + this.modelId, async() => {
				if (this_.modelIdOld) {
					await DeliveryQualityInspection.deleteData(this_,this_.modelIdOld);
				}
				// console.log('this.modelIdOld',this_.modelIdOld)
				// this.goToNext(toPage);
				return;
				}
			);
		},
		// setModel(model){
		// 	console.log('setModel',model)
		// 	if (this.modelId!=model.id) {
		// 		this.modelIdOld = this.modelId;
		// 	}
		// 	this.modelId = model.id;
		// 	this.model = model;
		// },
		async scanPart() {
			this.isScanPartLoading = true;
			let qrCode = encodeURIComponent(this.inputQrCodePart);
			// console.log('qrCode',qrCode);
			let id = this.model.id;
			let this_ = this;
			let toPage = 3;
			this.isScanPartLoading = true;
			this.DeliveryQualityInspectionScannerObject.partNumber = qrCode;
			// console.log('this.DeliveryQualityInspectionScannerObject',this.DeliveryQualityInspectionScannerObject.deliveryInstructionNumber);
			
			this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionDetailId = '';
			await DeliveryQualityInspectionScanner.doRequest(this,'scanPartDeliveryInstruction',this.DeliveryQualityInspectionScannerObject)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionDetailId = result.id;
						this_.selectedDeliveryQualityInspectionDetail = this_.DeliveryQualityInspectionDetails.find(q => q.id == result.id);
						this_.isScanPartLoading = false;
						this_.goToNext(toPage);
						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Instruction !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
				this.isScanPartLoading = false;
			});
			
			this.DeliveryQualityInspectionScannerObject.partNumber = '';
			this.inputQrCodePart = '';
			return;
		},
		clearMethodScanDeliveryCard(){
			this.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionCardId = '';
			this.waitInputScanDeliveryCard = false;
			this.$nextTick(() => {
				this.focusScanDeliveryCard();
			});
		},
		
		async scanDeliveryCard() {
			this.isScanDeliveryCardLoading = true;
			let qrCode = encodeURIComponent(this.inputQrCodeDeliveryCard);
			// console.log('qrCode',qrCode);
			let id = this.model.id;
			let this_ = this;
			let toPage = 3;
			this.isScanDeliveryCardLoading = true;
			this.DeliveryQualityInspectionScannerObject.deliveryCardNumber = qrCode;
			// console.log('this.DeliveryQualityInspectionScannerObject',this.DeliveryQualityInspectionScannerObject.deliveryInstructionNumber);

			this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionCardId = '';
			await DeliveryQualityInspectionScanner.doRequest(this,'scandeliverycard',this.DeliveryQualityInspectionScannerObject)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionCardId = result.id;
						this_.toast({message: 'Sukses melakukan scan delivery card !', title:'Sukses !', variant : 'success',autoHideDelay:750});
						this_.goToNext(toPage);
						
						this_.waitInputScanDeliveryCard = true;
						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'tidak ditemukan Delivery Instruction !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
			
			this.isScanDeliveryCardLoading = false;
			this.DeliveryQualityInspectionScannerObject.deliveryCardNumber = '';
			this.inputQrCodeDeliveryCard = '';
			return;
		},


		getVwDeliveryQualityInspections : async function(input){
			var vwDeliveryQualityInspectionFilter = new VwDeliveryQualityInspectionFilter();
			vwDeliveryQualityInspectionFilter.deliveryQualityInspectionStatusCodeEquals = [];
			vwDeliveryQualityInspectionFilter.deliveryQualityInspectionStatusCodeEquals.push("OPEN");
			vwDeliveryQualityInspectionFilter.deliveryQualityInspectionStatusCodeEquals.push("IN_PROGRESS");
			if (input != undefined) {
				vwDeliveryQualityInspectionFilter.deliveryInstructionNumber = input;
			}
			this.isVwDeliveryInstructionLoading = true;
			let sortingByVwPickingForDeliveryInstruction = [];
			sortingByVwPickingForDeliveryInstruction["deliveryinstructiondideliverydate"] = 1;
			// PickingCardDetail.getList(this, filter, this.sortingByVwPickingForDeliveryInstruction, currentPage , this.pickingCardDetailPageSize).then(result => {

			VwDeliveryQualityInspection.getListVw(this,vwDeliveryQualityInspectionFilter,sortingByVwPickingForDeliveryInstruction,0,10)
			.then((result)=>{
				this.vwDeliveryQualityInspections = result.data
				this.isVwDeliveryQualityInspectionLoading = false;
			})
			.catch(error => { this.isVwDeliveryQualityInspectionLoading = false; });
		},

		
		getDeliveryQualityInspectionDetails : async function(input){
			var deliveryQualityInspectionDetailFilter = new DeliveryQualityInspectionDetailFilter();
			if (input != undefined) {
				deliveryQualityInspectionDetailFilter.partNumber = input;
			}
			let NeedSearch = false;
			if (this.DeliveryQualityInspectionScannerObject!=null && this.DeliveryQualityInspectionScannerObject!=undefined && this.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId) {
				NeedSearch = true;
			}
			deliveryQualityInspectionDetailFilter.deliveryQualityInspectionId = this.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId ;
			deliveryQualityInspectionDetailFilter.isHideFullCheck = true;
			this.isVwDeliveryInstructionLoading = true;
			if (NeedSearch) {
				this.isDeliveryQualityInspectionDetailLoading = true;
				DeliveryQualityInspectionDetail.getList(this,deliveryQualityInspectionDetailFilter,null,0,10)
				.then((result)=>{
					this.DeliveryQualityInspectionDetails = result.data
					this.isDeliveryQualityInspectionDetailLoading = false;
				})
				.catch(error => { this.isDeliveryQualityInspectionDetailLoading = false; });
			}else{
				this.DeliveryQualityInspectionDetails = [];
			}
		},
		
		getQcStatus: async function (input) {
			this.isQcStatusLoading =true;
			let filter = new QcStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			filter.codeIn = ["OK", "PENDING", "NG"];
			filter.exactType.codeIn = 1;
			QcStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.QcStatuss = result.data;
					this.isQcStatusLoading =false;
				}
			})
			.catch(error => {
				this.isQcStatusLoading =false; 
			});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingForDeliveryInput.scrollTop = 0;
		},
		onHidden() {
			// this.getPickingForDeliverys();
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingForDeliveryDetail = false; 
			this.isShowPopupPickingForDeliveryDetail = false; 
			if (modalType == 'PickingForDeliveryDetail') {
				this.getPickingForDeliveryDetails();
			}
			this.isShowPopupUploadPickingCardDetail = false; 
			this.isShowPopupPickingCardDetail = false; 
			if (modalType == 'PickingCardDetail') {
				this.getPickingCardDetails();
			}
			this.inputQrCodeDiNumber = '';
			// this.inputQrCodeDetail = '';
			// this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		async goToNextByDeliveryInstruction(page,item){
			this.inputQrCodeDiNumber = item.deliveryInstructionNumber;
			// console.log('this.inputQrCodeDiNumber',this.inputQrCodeDiNumber)
			this.scanDeliveryInstruction();
		},
		goToNextBySelectPart(page,item){
			this.inputQrCodePart = item.part.partNumber;
			this.selectedDeliveryQualityInspectionDetail = item;
			this.scanPart();

		},
		// setVwPickingDetail(item){
		// 	this.selectedVwPickingForDeliveryDetail = item;
		// 	this.selectedPickingForDeliveryDetailId = item.pickingForDeliveryDetailId;

		// 	if (item.pickingForDeliveryDetailId==null || item.pickingForDeliveryDetailId==undefined) {
		// 		this.selectedPickingForDeliveryDetailId = '';
		// 	}
		// 	this.remarkInput = item.pickingForDeliveryDetailRemark==null || item.pickingForDeliveryDetailRemark==undefined?'':item.pickingForDeliveryDetailRemark;
		// },
		resetSavedValue(isVResetwPickingDetail=false){
			this.selectedDeliveryCard = null;
			this.selectedCaseSource = null;
			if (isVResetwPickingDetail) {
				this.selectedVwPickingForDeliveryDetail = null;
				this.selectedPickingForDeliveryDetailId = '';
			}

		},
		async finishDeliveryCard(){
			// console.log('this.selectedQcStatus',this.selectedQcStatus);
			// console.log('this.remarkInput',this.remarkInput);
			this.DeliveryQualityInspectionScannerObject.qcStatusId = this.selectedQcStatus;
			this.DeliveryQualityInspectionScannerObject.remark = this.remarkInput;
			let toPage = 2;
			let this_ = this;
			await DeliveryQualityInspectionScanner.doRequest(this,'finishInspectiondeliverycard',this.DeliveryQualityInspectionScannerObject)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionDetailId = '';
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionCardId = '';
						this_.waitInputScanDeliveryCard = false;
						//nanti go to next
						
						this_.toast({message: 'Sukses Melakukan Delivery Quality Inspection Card', title:'Sukses !', variant : 'success'});
						this_.getDeliveryQualityInspectionDetails();
						this_.goToNext(toPage);
						
						this_.selectedQcStatus ='';
						this_.remarkInput='';
						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'Gagal melakukan finish scan delivery card!';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
		},
		
		async finishScanDeliveryQualityInspection(){
			let toPage = 1;
			let this_ = this;
			await DeliveryQualityInspectionScanner.doRequest(this,'finishinspectiondeliveryinstruction',this.DeliveryQualityInspectionScannerObject)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					let result = response;
					if (result!=null && result!=undefined) {
						this_.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId = '';
						this_.toast({message: 'Sukses Melakukan Delivery Quality Inspection', title:'Sukses !', variant : 'success'});
						this_.getVwDeliveryQualityInspections();
						this_.goToNext(toPage);
						return;
					}
				}
				this_.toast({message: 'Delivery Instruction not found !(1)', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				var stringError = 'gagal melakukan finish scan delivery quality inspection !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				
			});
		},
		async nextAction(){
			let this_ = this;
			
			let selectedVwPickingForDeliveryDetailId = this.selectedVwPickingForDeliveryDetail!=null && this.selectedVwPickingForDeliveryDetail!=undefined ?this.selectedVwPickingForDeliveryDetail.id :'' ;
			let selectedDeliveryCardId = this.selectedDeliveryCard!=null && this.selectedDeliveryCard!=undefined ? this.selectedDeliveryCard.deliveryInstructionDeliveryCardId : 0;
			let selectedCaseSourceId = this.selectedCaseSource != null && this.selectedCaseSource!=undefined ?this.selectedCaseSource.id:0;

			this.$http.get('PickingForDelivery/NextScanDeliveryItem?pickingForDeliveryDetailId='+this.selectedPickingForDeliveryDetailId+'&selectedDeliveryCardId=' + selectedDeliveryCardId+'&selectedCaseSourceId=' + selectedCaseSourceId+'&remark=' + this.remarkInput)
			.then(async function(response){
				// console.log(response);
				if(response != null) {
					this_.resetSavedValue();
					
					// this_.getVwPickingForDeliveryDetailByPickingDetailId(this_.selectedPickingForDeliveryDetailId);

					this_.toast({message: 'Success melakukan scan delivery item', title:'Info', variant : 'success',autoHideDelay:750});
					return;
				}
				this_.toast({message: 'gagal menyimpan melakukan scan Delivery Instruction Item', title:'Error', variant : 'danger'});
			})
			.catch((error) => {
				// console.log(error)
				var stringError = 'gagal menyimpan !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				
				// this_.getVwPickingForDeliveryDetailByPickingDetailId(this_.selectedPickingForDeliveryDetailId);
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
			});
		},
		
		setModel(model){
			// console.log('setModel =>',model)
			if (this.modelId!=model.id) {
				this.modelIdOld = this.modelId;
			}
			this.modelId = model.id;
			this.DeliveryQualityInspectionScannerObject.deliveryQualityInspectionId =this.modelId;
			this.model = model;
		},
		
		goToNext(page, item) {
			this.scanPageIndex = page;
			if (page==1) {
				this.$nextTick(() => {
				this.focusScanDeliveryInstruction();
				})
			}
			else if (page==2) {
				this.$nextTick(() => {
					this.focusScanPart();
				})
				this.getDeliveryQualityInspectionDetails();
			}
			else if(page==3) {
				this.$nextTick(() => {
					this.focusScanDeliveryCard();
				})
			}

		},
		
		getDeliveryQualityInspection : async function(id) {
			this.isBusy = true;
			await DeliveryQualityInspection.getData(this, id).then(async (result) => {
				this.setModel(result);
				// console.log('DeliveryQualityInspection',result);
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
				await this.$nextTick(() => {
					if (result.deliveryInstructionId==null) {
						this.goToNext(1);
					return;
					}
					else if (this.model) {
						this.goToNext(2);
					}
				})
				

			}).catch(error => { this.isBusy = false; });
		},
	},
	beforeMount() {
		// this.filterPickingForDelivery = new PickingForDeliveryFilter();
		// this.filterPickingForDeliveryDetail = new PickingForDeliveryDetailFilter();
		// this.filterPickingCardDetail = new PickingCardDetailFilter();
	},
	async mounted(){
		this.getVwDeliveryQualityInspections();
		let id = this.$route.params.id;
		// console.log(id);
		// console.log('mounted with id =>',id)
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getDeliveryQualityInspection(id);
		}
		this.$nextTick(() => {
			
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		
		inputQrCodeDiNumber(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getVwDeliveryQualityInspections(newValue);
			} else {
				this.getVwDeliveryQualityInspections();
			}
		},
		inputQrCodePart(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getDeliveryQualityInspectionDetails(newValue);
			} else {
				this.getDeliveryQualityInspectionDetails();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
		// inputQrCodeDetail(newValue) {
		// 	if (newValue != null && newValue != undefined && newValue != '') {
		// 		this.getVwPickingForDeliveryDetail(newValue);
		// 	} else {
		// 		this.getVwPickingForDeliveryDetail();
		// 	}
		// },
	},
}
</script>
